module.exports = __webpack_public_path__ + "img/couple.290f58aa.svg";